export default __webpack_public_path__ + "static/media/result.c7d0b48b.pdf";